import React from 'react'
import UpdateProperty from '../Components/Property/UpdateProperty'

const UpdatePropertyPage = () => {
  return (
    <UpdateProperty />
  )
}

export default UpdatePropertyPage